import axios from "axios";
import { Base_URL } from "../url";

export const fetchDisbursements = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Disbursement/AmountDisbursementsGetApi`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching disbursements!";
  }
};